/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrebuiltCompositeManifestDto
 */
export interface PrebuiltCompositeManifestDto {
    /**
     * 
     * @type {string}
     * @memberof PrebuiltCompositeManifestDto
     */
    schemaVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof PrebuiltCompositeManifestDto
     */
    initiativePackSlug?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrebuiltCompositeManifestDto
     */
    defaultOrderedProjectPackSlugs?: Array<string>;
}

/**
 * Check if a given object implements the PrebuiltCompositeManifestDto interface.
 */
export function instanceOfPrebuiltCompositeManifestDto(value: object): value is PrebuiltCompositeManifestDto {
    return true;
}

export function PrebuiltCompositeManifestDtoFromJSON(json: any): PrebuiltCompositeManifestDto {
    return PrebuiltCompositeManifestDtoFromJSONTyped(json, false);
}

export function PrebuiltCompositeManifestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrebuiltCompositeManifestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'schemaVersion': json['schemaVersion'] == null ? undefined : json['schemaVersion'],
        'initiativePackSlug': json['initiativePackSlug'] == null ? undefined : json['initiativePackSlug'],
        'defaultOrderedProjectPackSlugs': json['defaultOrderedProjectPackSlugs'] == null ? undefined : json['defaultOrderedProjectPackSlugs'],
    };
}

export function PrebuiltCompositeManifestDtoToJSON(json: any): PrebuiltCompositeManifestDto {
    return PrebuiltCompositeManifestDtoToJSONTyped(json, false);
}

export function PrebuiltCompositeManifestDtoToJSONTyped(value?: PrebuiltCompositeManifestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'schemaVersion': value['schemaVersion'],
        'initiativePackSlug': value['initiativePackSlug'],
        'defaultOrderedProjectPackSlugs': value['defaultOrderedProjectPackSlugs'],
    };
}

